import { Type } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsNumber, IsString, ValidateNested } from 'class-validator';
import { MAX_BATCH_ARRAY_SIZE } from '../../constants/validation.constants';

export class SignEquipmentBatchItemDto {
  @IsString()
  equipmentId!: string;

  @IsNumber()
  temperature!: number;
}

export class SignEquipmentBatchDto {
  @IsArray()
  @ArrayMaxSize(MAX_BATCH_ARRAY_SIZE)
  @ValidateNested({ each: true })
  @Type(() => SignEquipmentBatchItemDto)
  equipment!: SignEquipmentBatchItemDto[];

  @IsString()
  signatureImage!: string;
}
